export default __webpack_public_path__ + "assets/bulgaria-flag.png";